import { useLazyQuery, useMutation } from "@apollo/client/react";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './misTareas.scss';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import EditOffIcon from '@mui/icons-material/EditOff';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { DateInput } from '../../../../components/dateInput/DateInput';
import moment from 'moment';
import 'moment/locale/es';
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { usePersistFilters } from '../../../../hooks/usePersistFilters';

import { GET_MIS_TAREAS_PAGINATED } from '../../../../data/graphQL/queries/MisTareas/getMisTareas';
import { adaptMisTareasArray } from '../../../../adapters/misTareasAdapter';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CustomChip } from '../../../../components/chip/Chip';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import toast from 'react-hot-toast';
import { RECHAZAR_TAREA_RI } from '../../../../data/graphQL/mutations/ResumenIngreso/rechazarTarea';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useGetBreakpoints } from "../../../../responsiveTools/breakpoints";

export const MisTareas = () => {

    const ESTADO_PENDIENTE = 1;
    const ESTADO_APROBADO = 2;
    const ESTADO_RECHAZADO = 3;

    const navigate = useNavigate();
    const location = useLocation();
    const { isMobile } = useGetBreakpoints();

    const [openFiltro, setOpenFiltro] = useState(false);
    const [verFiltroFecha, setVerFiltroFecha] = useState(false);
    const [lanzarBusqueda, setLanzarBusqueda] = useState(false);

    const rutasStorage = localStorage.getItem('navigationRoutes');
    const [allowedWrite, setAllowedWrite] = useState(false);

    useEffect(() => {
        if (rutasStorage) {
            const rutas = JSON.parse(rutasStorage);
            const rutaQueSirve = location.pathname;

            setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
            )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

        }
    }, [rutasStorage]);

    const fechasPermitidas = {
        fechaDesde: moment().add(-4, 'M').format("yyyy-MM-DD"),
        fechaHasta: moment().format("yyyy-MM-DD")
    };

    const initialFilters = {
        estado: ESTADO_PENDIENTE,
        fechaDesde: moment().add(-4, 'M').format("yyyy-MM-DD"),
        fechaHasta: moment().format("yyyy-MM-DD")
    };

    const [filtros, setFiltros] = useState(initialFilters);

    useEffect(() => {
        setLanzarBusqueda(true);
    }, [filtros.estado]);

    useEffect(() => {
    }, [lanzarBusqueda]);

    const handleChangeEstado = (event) => {
        const nuevoEstado = event.target.value;
        setFiltros((previousData) => ({
            ...previousData,
            estado: nuevoEstado
        }));

        setVerFiltroFecha(nuevoEstado == ESTADO_APROBADO);
    };

    const handleChangeFechaDesde = (value) => {
        const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : "";
        setFiltros((previousData) => ({
            ...previousData,
            fechaDesde: nuevaFecha
        }));
    };

    const handleChangeFechaHasta = (value) => {
        const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : "";
        setFiltros((previousData) => ({
            ...previousData,
            fechaHasta: nuevaFecha
        }));
    };

    const handleBuscar = () => {
        // valido que las fechas seleccionadas se encuentren dentro del rango permitido
        if (filtros.fechaDesde == "") {
            toast.error("La Fecha Desde es obligatoria.");
            return;
        }
        if (filtros.fechaHasta == "") {
            toast.error("La Fecha Hasta es obligatoria.");
            return;
        }
        if (filtros.fechaHasta < filtros.fechaDesde) {
            toast.error("La Fecha Hasta no puede ser anterior a la Fecha Desde.");
            return;
        }
        if (filtros.fechaDesde < fechasPermitidas.fechaDesde || filtros.fechaDesde > fechasPermitidas.fechaHasta) {
            toast.error("La Fecha Desde no es válida, no puede ser anterior al día " + moment(fechasPermitidas.fechaDesde).format("DD/MM/YYYY") + " ni posterior al día actual.");
            return;
        }
        if (filtros.fechaHasta < fechasPermitidas.fechaDesde || filtros.fechaHasta > fechasPermitidas.fechaHasta) {
            toast.error("La Fecha Hasta no es válida, no puede ser anterior al día " + moment(fechasPermitidas.fechaDesde).format("DD/MM/YYYY") + " ni posterior al día actual.");
            return;
        }

        setLanzarBusqueda(true);
        setOpenFiltro(false);
    };

    const handleClickEdit = (row) => {
        // Si está habilitado el servicio de GPS continúo con la edición del RI
        if (!navigator.geolocation)
            toast.error("Este navegador no soporta la geolocalización"); else {
            const successCallback = () => {
                navigate('/resumenIngreso/crearResumenIngreso',
                    {
                        state: {
                            idDatosGeneralesRI: row.idDatosGeneralesRI,
                            edit: true
                        }
                    });
            };

            const errorCallback = (error) => {
                if (error.code == error.PERMISSION_DENIED) {
                    toast(
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <InfoOutlinedIcon style={{ color: '#1976d2' }} />
                            Habilitar el GPS (ubicación) puede ayudarte a completar el formulario de forma más precisa.
                        </div>,
                        {
                            style: {
                                border: '1px solid #1976d2',
                                padding: '5px'
                            }
                        }
                    );
                }
                // POR EL MOMENTO SE REDIRECCIONA DE TODAS MANERAS PARA PODER PROBAR
                // COMENTAR LAS LINEAS SIGUIENTES PARA PRODUCCIÓN
                successCallback();
            };

            navigator.geolocation.getCurrentPosition(successCallback,
                errorCallback,
                {
                    maximumAge: 0,
                    timeout: 2000
                }
            );
        }
    };

    const [rechazarTarea] = useMutation(RECHAZAR_TAREA_RI, {
        fetchPolicy: 'no-cache',
        refetchQueries: [GET_MIS_TAREAS_PAGINATED],
        onCompleted: (data) => {
            toast.success('Se ha rechazado la tarea.');
            getMisTareas();
        }
    });

    const handleClickRechazar = (row) => {
        rechazarTarea({
            variables: {
                idDatosGenerales: row.idDatosGeneralesRI
            }
        });
    };

    const handleClickVer = (row) => {
        if (row.estado === ESTADO_APROBADO) {
            navigate('/resumenIngreso/detalle', { state: { idDatosGeneralesRI: row.idDatosGeneralesRI } });
        } else {
            navigate('/resumenIngreso/crearResumenIngreso',
                {
                    state: {
                        idDatosGeneralesRI: row.idDatosGeneralesRI,
                        edit: false
                    }
                });
        }
    };

    const handleClickVerAdjuntos = (row) => {
        navigate('/misTareas/documentos',
            {
                state: {
                    data: row
                }
            });
    };

    const {
        rows,
        setRows,
        misTareasLoading,
        handleChangePaginationStatus,
        paginationStatus,
        totalCount,
        filters,
        handleChangeFilters,
        selectedFilterByStatus,
        getMisTareas
    } = useGetMisTareas(filtros, lanzarBusqueda, setLanzarBusqueda);

    const initialColumns = [
        {
            headerName: '',
            field: 'action',
            flex: 1,
            maxWidth: 30,
            minWidth: 30,
            noPadding: true,
            sortable: false,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <>
                        <PopoverModal closeOnClick>
                            <div className='popover-modal-content'>
                                {
                                    filtros.estado == ESTADO_PENDIENTE &&
                                    <>
                                        <div
                                            onClick={() => handleClickEdit(row)} aria-hidden='true'
                                            className='item-option clickable-option'
                                        >
                                            <EditIcon className='edit-icon' />
                                            <span className='toggle-action'>Editar</span>
                                        </div>
                                        <div
                                            onClick={() => handleClickRechazar(row)} aria-hidden='true'
                                            className='item-option clickable-option'
                                        >
                                            <EditOffIcon className='edit-icon' />
                                            <span className='toggle-action'>Rechazar</span>
                                        </div>
                                    </>
                                }
                                {
                                    filtros.estado != ESTADO_PENDIENTE &&
                                    <div
                                        onClick={() => handleClickVer(row)} aria-hidden='true'
                                        className='item-option clickable-option'>

                                        <VisibilityIcon className='edit-icon' />
                                        <span className='toggle-action'>Ver</span>
                                    </div>
                                }
                                {row.tieneAdjuntos &&
                                    <div
                                        onClick={() => handleClickVerAdjuntos(row)} aria-hidden='true'
                                        className='item-option clickable-option'
                                    >
                                        <AttachFileIcon className='edit-icon' />
                                        <span className='toggle-action'>Ver Adjuntos</span>
                                    </div>
                                }
                            </div>
                        </PopoverModal>
                    </>);

            }
        },
        {
            field: 'paciente',
            flex: 6,
            headerName: 'Paciente'
        },
        {
            field: 'programa',
            headerName: 'Programa',
            flex: 2,
            ...(isMobile && { noPaddingHeader: true })
        },
        {
            field: 'fechaLimite',
            flex: 3,
            headerName: 'Vence',
            renderCell: ({ row }) => {
                const { fechaLimite } = row;
                return (
                    moment(fechaLimite).fromNow()
                );
            }
        },
    ];

    const columns = useMemo(
        () => generateColumnsDefaultConfiguration(initialColumns, isMobile),
        [filtros, allowedWrite, rows, isMobile]
    );

    return (
        <>
            <div className='general'>
                <Grid
                    container
                    justifyContent={'space-between'}>

                    <Grid size={{ xs: 12 }}>
                        <span className='span-row'>Estado</span>
                    </Grid>
                </Grid>

                <Grid
                    container>

                    <Grid size={{ xs: 10 }}>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-form-control-label-placement"
                                name="estado"
                                value={filtros?.estado || null}
                                onChange={handleChangeEstado}>

                                <FormControlLabel value={ESTADO_PENDIENTE} control={<Radio size='small' />} label="Pendientes" />
                                <FormControlLabel value={ESTADO_APROBADO} control={<Radio size='small' />} label="Realizadas" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {
                        verFiltroFecha &&
                        <Grid className='control-icon-right' size={{ xs: 2 }}>
                            <FilterAltOutlinedIcon className={isMobile ? undefined : 'icon'} onClick={() => setOpenFiltro(true)} />
                        </Grid>
                    }
                </Grid>

                <DataGridGenerico
                    columns={columns}
                    rows={rows}
                    toolbar={false}
                    loading={misTareasLoading}
                    onPageChange={(page) => {
                        if (isMobile) {
                            handleChangePaginationStatus({
                                ...paginationStatus,
                                page: page
                            });
                        } else {
                            handleChangePaginationStatus((prev) => ({
                                ...prev,
                                page: page
                            }));
                        }
                    }}
                    onPageSizeChange={(pageSize) => {
                        if (isMobile) {
                            handleChangePaginationStatus({
                                ...paginationStatus,
                                pageSize: pageSize,
                                page: 0
                            });
                        } else {
                            handleChangePaginationStatus((prev) => ({
                                ...prev,
                                pageSize: pageSize,
                                page: 0
                            }));
                        }
                    }}
                    pageSize={paginationStatus.pageSize}
                    totalCount={totalCount}
                    currentPage={paginationStatus.page} />

            </div>

            <CustomDialog
                open={openFiltro}
                maxWidth='xs'
                fullWidth={!isMobile}
                title='Filtro'
                onCancel={() => setOpenFiltro(false)}
                cancelText='Cerrar'
                acceptText='Buscar'
                onAccept={handleBuscar}>

                <div>
                    {isMobile ?
                        <>
                            <Grid
                                container
                                columns={{
                                    xs: 2
                                }}
                                spacing={1}>

                                <Grid size={{ xs: 1.3 }}>
                                    <DateInput
                                        label="Fecha Desde"
                                        value={filtros?.fechaDesde}
                                        onChange={handleChangeFechaDesde} />

                                </Grid>
                            </Grid>
                            <br />
                            <Grid
                                container
                                columns={{
                                    xs: 2
                                }}
                                spacing={1}
                                sx={{ marginTop: '1px' }}>

                                <Grid size={{ xs: 1.3 }}>
                                    <DateInput
                                        label="Fecha Hasta"
                                        value={filtros?.fechaHasta}
                                        onChange={handleChangeFechaHasta} />

                                </Grid>
                            </Grid>
                        </> :

                        <Grid
                            container
                            columns={{
                                xs: 2
                            }}
                            spacing={1}>

                            <Grid size={{ xs: 1 }}>
                                <DateInput
                                    label="Fecha Desde"
                                    value={filtros?.fechaDesde}
                                    onChange={handleChangeFechaDesde} />

                            </Grid>

                            <Grid size={{ xs: 1 }}>
                                <DateInput
                                    label="Fecha Hasta"
                                    value={filtros?.fechaHasta}
                                    onChange={handleChangeFechaHasta} />

                            </Grid>
                        </Grid>
                    }
                </div>
            </CustomDialog>
        </>);

};

const useGetMisTareas = (filtros, lanzarBusqueda, setLanzarBusqueda) => {

    const [MisTareasData, setMisTareasData] = useState([]);
    const [paginationStatus, setPaginationStatus] = useState({
        pageSize: 10,
        page: 0
    });
    const [orderBy, setOrderBy] = useState({
        fieldName: 'fechaLimite',
        order: 'ASC'
    });

    const { filters, handleChangeFilters } = usePersistFilters(
        {
            fechaDesde: filtros.fechaDesde,
            fechaHasta: filtros.fechaHasta,
            idEstado: filtros.estado
        },
        'misTareasFilters'
    );

    const {
        fechaLimite
    } = filters;

    const [queryMisTareas, { data: misTareasData, loading: misTareasLoading }] = useLazyQuery(GET_MIS_TAREAS_PAGINATED, {
        fetchPolicy: 'network-only'
    });

    useEffect(() => {
        if (!misTareasData) return;
        setMisTareasData(misTareasData);
    }, [misTareasData]);

    const getMisTareas = useCallback(() => {
        if (!misTareasLoading) {
            queryMisTareas({
                variables: {
                    idEstado: parseInt(filtros.estado, 10),
                    fechaDesde: filtros.fechaDesde,
                    fechaHasta: filtros.fechaHasta,
                    skip: paginationStatus.page * paginationStatus.pageSize,
                    take: paginationStatus.pageSize,
                    where: {},
                    order: [{
                        [orderBy?.fieldName]: orderBy?.order?.toUpperCase()
                    }]
                }
            });
        }
    }, [paginationStatus, filtros, orderBy, misTareasLoading]);

    useEffect(() => {
        getMisTareas();
    }, [paginationStatus, filtros.estado, lanzarBusqueda]);

    return {
        rows: adaptMisTareasArray(MisTareasData) || [],
        setRows: setMisTareasData,
        misTareasLoading,
        handleChangePaginationStatus: setPaginationStatus,
        paginationStatus,
        totalCount: MisTareasData?.misTareas?.totalCount,
        filters,
        handleChangeFilters,
        getMisTareas
    };
};